import {FC} from "react";
import Icon from '../Icon/Icon.tsx';
import { IconTypes } from '../Icon/Icon-Constants.ts';
import "./Quotes.scss";

interface QuotesProps {
  quote: string;
  attribution?: string;
  getNewQuote: () => void;
}

const Quotes: FC<QuotesProps> = ({quote, attribution, getNewQuote}) => {
  const handleClick = () => {
    getNewQuote();
  }

  return (
    <div className="quotes" onClick={handleClick}>
      <div className="quotes__icon">
        <div className="quotes__begin"></div>
        <div className="quotes__end"></div>
      </div>
      <div className="quotes__content">
        <blockquote className="quotes__message">
          <div className="quotes__text">
            {quote}
          </div>
          {attribution && (
            <cite className="quotes__attribution body-md">
              {attribution}
            </cite>
          )}
        </blockquote>
        <div className="quotes__refresh">
          <Icon name={IconTypes.refresh} />
        </div>
      </div>
    </div>
  )
}

export default Quotes; 
